import React from "react";
import AdminProductCard from "../../components/AdminProductCard";
import ProductQuickEdit from "./ProductQuickEdit";

export default function ProductsGrid({
  products,
  rowUI,
  toggleRowOpen,
  setRowUiField,
  handleLocalChange,
  handleSave,
  savingId,
  onDeleteExistingImage, // <— make sure this is accepted
}) {
  const handleEdit = (product, done) => {
    // Save callback so the edit pane can call it on Cancel/Save
    setRowUiField(product.id, "onDone", done);
    // Open row if closed
    if (!rowUI[product.id]?.open) toggleRowOpen(product.id);
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {products.map((p) => {
        const ui = rowUI[p.id] || {
          files: [],
          urlsText: "",
          open: false,
        };

        const cardProduct = {
          id: p.id,
          name: p.product_name,
          price: p.price ?? 0,
          description: p.description || "",
          subname: p.subname || "",
          sponsored: !!p.sponsored,
          images: (p.images || []).filter((img) => !!img.filename),
          apiImage: p.image_url,
          tag: p.product_group_name,
          stock: p.stock_count,
          is_active: p.is_active
        };

        return (
          <div key={p.id} className="rounded-xl border shadow-sm bg-white">
            <div className="p-4">
              <AdminProductCard product={cardProduct} onEdit={handleEdit} />
            </div>

            {ui.open && (
              <ProductQuickEdit
                p={p}
                ui={ui}
                setRowUiField={setRowUiField}
                handleLocalChange={handleLocalChange}
                handleSave={handleSave}
                savingId={savingId}
                toggleRowOpen={toggleRowOpen}
                onDeleteExistingImage={onDeleteExistingImage} // <— pass this through
              />
            )}
          </div>
        );
      })}

      {products.length === 0 && (
        <div className="col-span-full text-center text-gray-500 py-10">
          No products match your search.
        </div>
      )}
    </div>
  );
}
